import Viewer from 'viewerjs'
import _ from 'lodash'
import 'viewerjs/dist/viewer.css'

export default (el, opts = {}) => {
  let $opts = {
    filter (img) {
      if ((img.dataset['preview'] !== undefined && img.dataset['preview'] !== null) && img.src) {
          img.style.cursor = 'pointer'
          img.style['object-fit'] = 'cover'
        return true
      }
      return false
    }
  }
  $opts = _.merge({}, $opts, opts)
  return new Viewer(el, $opts)
}



// WEBPACK FOOTER //
// ./src/components/framework/directives/viewer.js